import gql from 'graphql-tag'

// USED IN: ACTION_STREAM
export const GetScriptById = gql`
  query GetScriptById($id: ID!) {
    macros(input: {
      ids: [$id],
      includeFields: true
    }) {
      count,
      results {
        id,
        blocks {
          sectionId
        }
      }
    }
  }
`

export const GetScript = gql`
  query GetScript($id: ID!) {
    macros(input: {
      ids: [$id]
      includeFields: true
    }) {
      count
      results {
        id
        tags {
          type
          name {
            value
            aliases
          }
        }
        blocks {
          sectionId
          sectionName
          content
        }
        contentType
      }
    }
  }
`

// USED IN: ACTION_STREAM
export const GetScriptsByUserId = gql`
  query GetScriptsByUserId($userId: ID!) {
    macros(input: { userId: $userId, includeFields: true }) {
      count
      results {
        id
        userId
        tags {
          type
          name {
            value
            aliases
          }
        }
        blocks {
          sectionId,
          content,
          fields {
            name {
              value,
              aliases
            },
            type
          }
        }
        contentType
      }
    }
  }
`
// USED IN: VEIL
export const UpdateScript = gql`
  mutation UpdateScript(
    $organizationId: ID!,
    $id: ID!,
    $userId: ID,
    $tags: [TagInput!]!,
    $blocks: [BlockInput!]!
  ) {
    updateMacro(
      input: {
        organizationId: $organizationId,
        macro: { id: $id, userId: $userId, tags: $tags, blocks: $blocks, source: USER }
      }
    ) {
      macro {
        id
        userId
        tags {
          type
          name {
            value
            aliases
          }
        }
        blocks {
          sectionId
          content
        }
        source
      }
    }
  }
`

export const CreateScript = gql`
  mutation CreateScript($organizationId: ID!, $userId: ID, $name: String!, $blocks: [BlockInput] ) {
    createMacro(
      input: {
        organizationId: $organizationId
        userId: $userId
        tags: [{ name: { value: $name }, type: MACRO_NAME }]
        source: USER
        blocks: $blocks
      }
    ) {
      macro {
        id
        userId
        tags {
          type
          name {
            value
            aliases
          }
        }
        blocks {
          sectionId
          content
        }
        source
      }
    }
  }
`

// USED IN: SCRIPT_MANAGER
export const DeleteScript = gql`
  mutation DeleteScript($organizationId: ID!, $id: ID!) {
    deleteMacros(input: { organizationId: $organizationId, ids: [$id] }) {
      ids
    }
  }
`
